import { Chip } from "@assetwatch/ui";
import type { RequestPriority } from "../../../types/workRequest";

const priorityPresentation = {
  NONE: { label: "None", tone: "neutral" },
  HIGH: { label: "High", tone: "negative" },
  MEDIUM: { label: "Medium", tone: "warning" },
  LOW: { label: "Low", tone: "neutral" },
} as const;

type RequestPriorityChipProps = {
  priority: RequestPriority | null;
};

export function RequestPriorityChip({ priority }: RequestPriorityChipProps) {
  const presentation = priority
    ? priorityPresentation[priority]
    : { label: "Not set", tone: "neutral" as const };

  return <Chip label={presentation.label} tone={presentation.tone} />;
}
